import { render } from "./Index.vue?vue&type=template&id=340a06ee"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/delta-logs/components/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "340a06ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('340a06ee', __exports__)) {
    api.reload('340a06ee', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=340a06ee", () => {
    api.rerender('340a06ee', render)
  })

}


export default __exports__